import * as Types from '@/types';

import { gql } from '@apollo/client';
export const ProspectDetails_AutoFillBigIntFieldsFragmentDoc = gql`
  fragment ProspectDetails_AutoFillBigIntFields on ChatProspectAutoFillBigIntField {
    source
    filled_at
    confidence
    value
  }
`;
export const ProspectDetails_AutoFillStringFieldsFragmentDoc = gql`
  fragment ProspectDetails_AutoFillStringFields on ChatProspectAutoFillStringField {
    source
    filled_at
    confidence
    value
  }
`;
export const ProspectDetails_AutoFillStringListFieldsFragmentDoc = gql`
  fragment ProspectDetails_AutoFillStringListFields on ChatProspectAutoFillStringListField {
    source
    filled_at
    confidence
    value
  }
`;
export const ProspectDetails_FieldsFragmentDoc = gql`
  fragment ProspectDetails_Fields on SalesPortalProspectDetails {
    uuid
    chat_id
    stage
    processing_status
    last_refreshed_at
    owned_by_id
    weekly_estimated_value_in_micros {
      ...ProspectDetails_AutoFillBigIntFields
    }
    contact_name {
      ...ProspectDetails_AutoFillStringFields
    }
    contact_role {
      ...ProspectDetails_AutoFillStringFields
    }
    contact_phone {
      ...ProspectDetails_AutoFillStringFields
    }
    contact_email {
      ...ProspectDetails_AutoFillStringFields
    }
    incumbents {
      ...ProspectDetails_AutoFillStringListFields
    }
    estimated_close_date {
      ...ProspectDetails_AutoFillStringFields
    }
  }
  ${ProspectDetails_AutoFillBigIntFieldsFragmentDoc}
  ${ProspectDetails_AutoFillStringFieldsFragmentDoc}
  ${ProspectDetails_AutoFillStringListFieldsFragmentDoc}
`;
